<template>
  <div></div>
</template>

<script>
export default {
  name: "SecuritySetting"
}
</script>

<style scoped>

</style>